import { Component, input } from '@angular/core';
import { ExamSummary } from '../../../dtos/exam-summary';
import { ExamStatus, isExamStatusDone } from '$synapse/models';
import { SHARED_IMPORTS } from '../../shared-imports';
import { StatusAvatarComponent } from '$synapse/core';
import { CertifiedAssessmentIconComponent } from '../certified-assessment-icon/certified-assessment-icon.component';

@Component({
  selector: 'syn-exam-accordion',
  templateUrl: './exam-accordion.component.html',
  styleUrls: ['./exam-accordion.component.scss'],
  imports: [
    SHARED_IMPORTS,
    StatusAvatarComponent,
    CertifiedAssessmentIconComponent,
  ],
})
export class ExamAccordionComponent {
  readonly groupedTests = input<
    {
      label: string;
      status: ExamStatus;
      duplicates: ExamSummary[];
    }[]
  >([]);
  panelOpenState = false;
  readonly isExamStatusDone = isExamStatusDone;
}
